import type { CookieRef } from '#app';

export type CookiesPermission = 'accepted' | 'not accepted';

interface UseAllowCookiesReturn {
	cookiesAccepted: CookieRef<CookiesPermission>;
	acceptCookies: () => void;
}

export function useAllowCookies(): UseAllowCookiesReturn {
	const oneYear = 1000 * 60 * 60 * 24 * 365;

	const cookiesAccepted = useCookie<CookiesPermission>('cookies-accepted', {
		maxAge: oneYear,
		watch: true,
		sameSite: true
	});

	const { emit } = useEventBus('cookies-accepted');

	function setCookiesPermission(permission: CookiesPermission) {
		cookiesAccepted.value = permission;
	}

	function acceptCookies() {
		setCookiesPermission('accepted');
		emit();
	}

	return {
		cookiesAccepted,
		acceptCookies
	};
}
